import { render } from "./SoleTraderDashboard.vue?vue&type=template&id=5335203c&scoped=true&ts=true"
import script from "./SoleTraderDashboard.vue?vue&type=script&lang=ts"
export * from "./SoleTraderDashboard.vue?vue&type=script&lang=ts"

import "./SoleTraderDashboard.vue?vue&type=style&index=0&id=5335203c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5335203c"]])

export default __exports__